import Vue from 'vue';
import Vuelidate from 'vuelidate';
import axios from 'axios';
import { VueReCaptcha } from 'vue-recaptcha-v3'

import { email, minLength, required } from 'vuelidate/lib/validators';

import { analyticsAlias, analyticsIdentify, analyticsTrack, analyticsTrackRetry, getHightouchId } from './analytics_wrapper';


Vue.use(Vuelidate);
Vue.use(VueReCaptcha, { siteKey: '6LfCy_MZAAAAAOYoaD-PgnPKlBUGq8iH0xqt3YnI' });

if (typeof(Sentry) === 'object') {
    Sentry.init({
        dsn: 'https://2fb472ccf101450bb2a4bab2b526f5ac@sentry.io/1339924',
        integrations: [new Sentry.Integrations.Vue({Vue, attachProps: true})]
    });
}


const validPhone = (value) => /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/.test(value);

new Vue({
    el: '.form-basic',
    data: {
        form: {
            "name1": "",
            "name2": "",
            "company1": "",
            "email1": "",
            "phone1": "",
            "assets": [],
            "features": [],
            "assetcount": "",
            "recaptchaToken": "",
            "keyword": "",
            "utm_campaign": "",
            "utm_source": "",
            "utm_medium": "",
            "utm_content": "",
            "utm_term": "",
            "utm_ts": "",
            "utm_ext_ad_id": "",
            "utm_ext_adset_id": "",
            "utm_ext_campaign_id": "",
            "fpv": "",
            "referrer": "",
            "ip_address": "",
            "ip_data": "",
            "quant_id": "",
            "mixpanel_id": "",
            "cid": "",
            "experimentName": "",
            "gclid": "",
            "_mkto_trk": "",
            "is_partner": "",
            "msclkid": "",
            "phoneValid": null,
            "phoneType": "",
            "emailValid": null,
            "referralID": ""
        },
        gdpr: [],
        validateName: false,
        validateCompany: false,
        validateEmail: false,
        validatePhone: false,
        validateAssets: false,
        validateFeatures: false,
        validateAssetCount: false,
        validateGDPR: false,
        validatePartner: false,
        displayError: false,
        currentRoute: window.location.pathname,
        max: $("#jinja-data").data("max") - 1,
        animating: false,
        step: 0,
        ipFetched: false,
        isEU: false,
        functionalOptIn: true,
        analyticsOptIn: true,
        advertisingOptIn: true
    },
    validations: {
        form: {
            "name1": {
                required,
                minLength: minLength(2)
            },
            "name2": {
                required,
                minLength: minLength(2)
            },
            "company1": {
                required,
                minLength: minLength(2)
            },
            "email1": {
                required,
                email,
                minLength: minLength(2)
            },
            "phone1": {
                required,
                validPhone,
                uniqueCharacterLimit () {
                    return this.countUniqueCharacters(this.form["phone1"]) > 3;
                }
            }
        }
    },
    computed: {
        isInvalid () {
            let validityChecks = [];
            if (this.validateName) {
                validityChecks.push(this.$v.form["name1"].$invalid
                    || this.$v.form["name2"].$invalid);
            }
            if (this.validateCompany) {
                validityChecks.push(this.$v.form["company1"].$invalid);
            }
            if (this.validateEmail) {
                validityChecks.push(this.$v.form["email1"].$invalid);
            }
            if (this.validatePhone) {
                validityChecks.push(this.$v.form["phone1"].$invalid);
            }
            if (this.validateAssets) {
                validityChecks.push(this.form["assets"].length == 0);
            }
            if (this.validateFeatures) {
                validityChecks.push(this.form["features"].length == 0);
            }
            if (this.validateAssetCount) {
                validityChecks.push(this.form["assetcount"].length == 0);
            }
            if (this.validateGDPR) {
                validityChecks.push(this.gdpr.length == 0);
            }
            if (this.validatePartner) {
                validityChecks.push(this.form["is_partner"].length == 0);
            }
            return validityChecks.includes(true) ? true : false;
        }
    },
    methods: {
        setReferralID: function () {
            const urlParams = new URLSearchParams(window.location.search);
            const referralID = urlParams.get('referralID', '');
            this.form['referralID'] = referralID;
        },
        resetValidation: function () {
            this.validateName = false;
            this.validateCompany = false;
            this.validateEmail = false;
            this.validatePhone = false;
            this.validateAssets = false;
            this.validateFeatures = false;
            this.validateAssetCount = false;
            this.validateGDPR = false;
            this.validatePartner = false;
        },
        removeDisplayError: function () {
            this.displayError = false;
        },
        detectCurrentInput: function () {
            const page = $("#pricing-form > fieldset").eq(this.step);
            let inputs = [];
            page.find("input").each(function() {
                inputs.push(this.name);
            });
            // Remove duplicates from list
            return inputs.filter((variable, index, array) => array.indexOf(variable) === index);
        },
        setValidation: function (inputs) {
            for (let i in inputs) {
                if (inputs[i] === 'name') {
                    this.validateName = true;
                } else if (inputs[i] === 'email') {
                    this.validateEmail = true;
                } else if (inputs[i] === 'phone') {
                    this.validatePhone = true;
                } else if (inputs[i] === 'company') {
                    this.validateCompany = true;
                } else if (inputs[i] === 'assets') {
                    this.validateAssets = true;
                } else if (inputs[i] === 'assetcount') {
                    this.validateAssetCount = true;
                } else if (inputs[i] === 'features') {
                    this.validateFeatures = true;
                } else if (inputs[i] === 'gdpr'){
                    this.validateGDPR = true;
                } else if (inputs[i] === 'is_partner'){
                    this.validatePartner = true;
                } else {
                    // It's type button, don't validate
                }
            }
        },
        countUniqueCharacters: function (characters) {
            return characters.split('').filter(function(item, i, ar){ return ar.indexOf(item) === i; }).join('').length;
        },
        setIPData: function(ipData){
            if (!ipData['is_eu']) {
                this.form['ip_address'] = ipData['ip'];
                if (ipData['country_name'] === 'United States' ||
                    ipData['country_name'] === 'United States of America' ||
                    ipData['country_name'] === 'Canada') {
                    this.form['ip_data'] = JSON.stringify(ipData);
                }
            } else {
                this.isEU = true;
            }

            this.ipFetched = true;
            this.setGDPROptInPreferences();
        },
        getIP: function () {
            // Get IP address from app.ipgeolocation.io
            const apiKey = 'ee1c98bfac844278a953668b27afee0f';
            axios.get('https://api.ipgeolocation.io/ipgeo?apiKey=' + apiKey).then(response => {
                if(response.status === 200) {
                    this.setIPData(response['data']);
                } else {
                    console.error("Geolocation failed.");
                }
            })
        },
        verifyEmail: async function () {
            try {
                let response = await axios({
                    method: 'post',
                    url: '/validate',
                    headers: {
                        'Content-type': 'application/json'
                    },
                    data: {
                        inputToValidate: 'email',
                        email: this.form['email1']
                    }
                })
                if(response.status === 200) {
                    this.form['emailValid'] = response.data.status === 'valid';
                }
            } catch(e) {
                console.error("Email verification failed.");
            }
        },
        verifyPhone: async function () {
            try {
                const response = await axios({
                    method: 'post',
                    url: '/validate',
                    headers: {
                        'Content-type': 'application/json'
                    },
                    data: {
                        inputToValidate: 'phone',
                        phone: this.form['phone1']
                    }
                })
                if(response.status === 200) {
                    this.form['phoneValid'] = response.data.valid;
                    this.form['phoneType'] = response.data.line_type;
                }
            } catch(e) {
                console.error("Phone verification failed.");
            }
        },
        freeEmail: function () {
            const freeEmailProviders = ['gmail.', 'yahoo.', 'outlook.', 'aol.',
            'hotmail.', 'icloud.', 'ymail.', 'msn.', 'comcast.'];

            return freeEmailProviders.some(provider => this.form['email1'].includes(provider));
        },
        getCookie: function (cname) {
            let name = cname + '=';
            let decodedCookie = decodeURIComponent(document.cookie);
            let cookie = decodedCookie.split(';');
            for (let i = 0; i < cookie.length; i++) {
                let char = cookie[i];
                while (char.charAt(0) == ' ') {
                    char = char.substring(1);
                }
                if (char.indexOf(name) == 0) {
                    return char.substring(name.length, char.length);
                }
            }
            return ''
        },
        setGDPROptInPreferences: function () {
            if (this.isEU === true) {
                const cookie_preferences = this.getCookie('samsara_cookies');
                this.functionalOptIn = false;
                this.analyticsOptIn = false;
                this.advertisingOptIn = false;
                if (cookie_preferences.includes('fn')) {
                    this.functionalOptIn = true;
                }
                if (cookie_preferences.includes('an')) {
                    this.analyticsOptIn = true;
                }
                if (cookie_preferences.includes('ad')) {
                    this.advertisingOptIn = true;
                }
            }
        },
        setCookie: function (cname, cvalue, exdays) {
            var date = new Date();
            date.setTime(date.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = 'expires=' + date.toUTCString();
            document.cookie = cname + '=' + decodeURI(cvalue) + ';' + expires + ';path=/';
        },
        saveInputToStorage: function () {
            for (let key in this.form) {
                if (Object.prototype.hasOwnProperty.call(this.form, key)) {
                    let input = this.form[key];
                    if (input != undefined && input != "") {
                        if (Array.isArray(input)) {
                            localStorage.setItem(key, input.join(","));
                        } else {
                            localStorage.setItem(key, input);
                        }
                    }
                }
            }
        },
        loadSessionFromStorage: function() {
            for (let key in this.form) {
                if (Object.prototype.hasOwnProperty.call(this.form, key)) {
                    let input = localStorage.getItem(key);
                    if (input != undefined && input != "") {
                        if (key === 'assets' || key === 'features') {
                            this.form[key] = input.split(',');
                        } else {
                            this.form[key] = input;
                        }
                    }
                }
            }
        },
        format: function (input) {
            // Replace ' ' with '_', remove non alphanumerics and set to lowercase
            return input.replace(/ /g, "_").replace(/[\W]/g, "").toLowerCase();
        },
        setupOptimizely: function () {
            this.form['experimentName'] = this.getCookie('optimizelyEndUserId');
        },
        buttonHelper: function(next) {
            if (next && this.step == this.max) {
                localStorage.clear();
            } else if (next && this.step != this.max) {
                this.step++;
            } else {
                this.step--;
            }
        },
        animationHelper: function(mode, next, current, previous) {
            this.animating = true;
            // Set fieldssets to animate
            var slide, fade;
            mode === "next" ? slide = next : slide = current;
            slide === next ? fade = current : fade = previous;

            // Show previous or next fieldsets
            mode === "next" ? (current.css({'max-height': '0%'}), next.show()) :
                (previous.css({'max-height': '0%'}), previous.show());
            $("#btn-group").hide();
            fade.animate({opacity: mode === "next" ? 0 : 1}, {
                step: function(now) {
                    // Set scale (decrease if next)
                    // Move slide (send to left if next)
                    var left = (now * 50) + "%";
                    fade.css({'transform': 'scale('+(0.8 + now * 0.2)+')'});
                    slide.css({'left': left,'opacity': 1 - now});
                },
                duration: 300,
                complete: function() {
                    current.hide();
                    previous.css({'max-height': ''});
                    current.css({'max-height': ''});
                    $("#btn-group").show();
                    this.animating = false;
                }
            });
            this.animating = false;
        },
        progressHelper: function(next) {
            const curr = $("#progressbar div").eq(this.step);
            // Reset next or previous
            next ? $(curr).prev().removeClass("active") :
                $(curr).next().removeClass("active");

            // Set current
            $(curr).addClass("active");
        },
        keyCheck: function(e) {
            if (e.keyCode !== 13) {
                return false;
            }
            if (this.step === this.max) {
                this.submitForm();
            } else {
                this.goToNextPage();
            }
        },
        trackStep: function () {
            let properties = {
                'page name' : document.title,
                'url' : this.currentRoute,
                'current step' : this.step,
                'max steps': this.max,
                'ip address': this.form['ip_address']
            }
            // If assetcount exists (and is not 0), send it to segment
            if (this.form["assetcount"]) {
                let assetCount = {"Asset Count": this.form["assetcount"]};
                analyticsTrack('free trial form step', {...properties, ...assetCount});
            } else {
                analyticsTrack('free trial form step', properties);
            }
        },
        getFormData: function () {
            if (!this.ipFetched) {
                this.getIP();
            }

            if (!this.form['mixpanel_id'] && window.hasOwnProperty('analytics')) {
                try {
                    // the mixpanel_id actually holds the segment id moving forward
                    // we are not renaming it because this form will be deprecated soon
                    let distinct_id = getHightouchId();
                    this.form['mixpanel_id'] = distinct_id ? distinct_id : '';
                } catch(e) {
                    Sentry.captureException(e);
                }
            }

            if (this.analyticsOptIn === true && !this.form['experimentName']) {
                this.setupOptimizely();
            }
        },
        goToNextPage: async function() {
            if (this.isInvalid) {
                this.displayError = true;
                return false;
            }
            // If email step, make api call and wait for response
            // before changing page, else change page
            if (this.validateEmail) {
                this.verifyEmail();
            }
            this.pageChanger('next');
            this.trackStep();
            this.getFormData();
        },
        goToPreviousPage: function() {
            this.pageChanger("previous");
        },
        pageChanger: function(mode) {
            if (this.animating) {
                return false;
            }

            // Instantiate local animation variables
            const current = $("#pricing-form > fieldset").eq(this.step);
            const next = $(current).next();
            const previous = $(current).prev();

            // Hide warnings until we hit submit
            $("#warning").html("").hide();

            // Toggle buttons
            this.buttonHelper(mode === "next");

            // Toggle progress bar
            this.progressHelper(mode === "next");

            // Animate transition
            this.animationHelper(mode, next, current, previous);

            this.displayError = false;
            this.resetValidation();
            const currentInput = this.detectCurrentInput();
            this.setValidation(currentInput);
        },
        identify() {
            const email = this.form['email'];
            const assetcount = this.form['assetcount'];
            const assets = this.form['assets'];
            const features = this.form['features'];
            const company = this.form['company'];

            analyticsAlias(email);
            analyticsIdentify(email, { email, "asset_count": assetcount, assets, features, company });
            analyticsTrack('Form Submitted');
        },
        async recaptcha() {
            await this.$recaptchaLoaded()
            const token = await this.$recaptcha('login')
            this.form['recaptchaToken'] = token;
        },
        submitForm: async function () {
            if (this.isInvalid) {
                this.displayError = true;
                return false;
            }
            if (this.validatePhone) {
                await this.verifyPhone();
            }

            this.step++;

            // Segment integration
            analyticsTrack('free trial form step', {
                'page name' : document.title,
                'url' : this.currentRoute,
                'current step' : this.step,
                'max steps': this.max,
                'ip address': this.form['ip_address']
            });
            await this.recaptcha();
            this.identify();


            // Defer the form submit to be executed after the next DOM update cycle.
            // This ensures that the phoneValid, phoneType and emailValid values
            // can update the form inputs before submitting.
            this.$nextTick(function () {
                this.$refs.form.submit();
            });
        }
    },
    created() {
        window.addEventListener('beforeunload', this.saveInputToStorage);
    },
    mounted() {
        let currentInput = this.detectCurrentInput();
        this.setValidation(currentInput);

        this.loadSessionFromStorage();

        this.getIP();

        // Load utm parameters from cookie
        const inputs =
            [
                "keyword",
                "utm_campaign",
                "utm_source",
                "utm_medium",
                "utm_content",
                "utm_term",
                "utm_ts",
                "utm_ext_ad_id",
                "utm_ext_adset_id",
                "utm_ext_campaign_id",
                "fpv",
                "referrer",
                "cid",
                "gclid",
                "_mkto_trk",
                "msclkid"
            ];

        if (this.advertisingOptIn === true) {
            // Set up advertising cookies
            for (let index in inputs) {
                let inputValue = this.getCookie(inputs[index]);
                if (inputValue != "" && inputValue != null) {
                    this.form[inputs[index]] = inputValue;
                }
            }

            // The quantcast cookie needs to be set because it is used as orderId
            // in the tracking pixel on the thank you pages. The orderId is used
            // by quantcast for attribution.
            if (!this.getCookie('quantcast_id')) {
                // If the cookie doesn't exist we create it and assign the value to the form
                this.form['quant_id'] = (1 + Math.random()).toString(36).substr(2, 9);
                this.setCookie('quantcast_id', this.form['quant_id'], 90);
            } else {
                // If the cookie is already defined, we assign it to the form value
                this.form['quant_id'] = this.getCookie('quantcast_id');
            }
        }

        // Segment integration
        analyticsTrackRetry('free trial form step', {
            'page name' : document.title,
            'url' : this.currentRoute,
            'current step' : 0,
            'max steps': this.max
        });

        this.setReferralID();
    },
    delimiters: ['[[',']]']
});
